import axios from 'axios';
import axiosInstance from '../axiosInstance';

export const applyJob = async (jobId, data = {}) => {
  try {
    const response = await axiosInstance.post(`/job/apply/${jobId}`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Apply Job API Error:', error);
    throw error;
  }
};

export const getUploadUrl = async (fileName, jobId) => {
  const res = await axiosInstance.post('/job/apply/upload-url', null, {
    params: { fileName, jobId },
  });

  return res.data.data;
};

export const uploadToS3 = async (file, uploadUrl, onProgress) => {
  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: (progressEvent) => {
      if (!progressEvent.total) return;

      const loaded = progressEvent.loaded;
      const total = progressEvent.total;

      const percent = Math.round((loaded * 100) / total);

      onProgress({
        percent,
        loaded,
        total,
      });
    },
  });
};

export const getApplyStatus = async (jobId) => {
  try {
    const response = await axiosInstance.get(`/job/apply/${jobId}/status`);
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get Apply Status API Error:', error);
    throw error;
  }
};

export const getMyApplies = async (
  period = 'ALL',
  status = 'ALL',
  page = 0,
  size = 7
) => {
  try {
    const params = { page, size };
    if (period !== 'ALL') params.period = period;
    if (status !== 'ALL') params.status = status;

    const response = await axiosInstance.get('/job/apply/me', { params });
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get My Applies API Error:', error);
    throw error;
  }
};

// 구직활동 증명서용 — 페이징 없이 지원내역 (period: ALL | 1M | 3M | 4M)
export const getAllMyApplies = async (period = 'ALL') => {
  try {
    const params = {};
    if (period && period !== 'ALL') params.period = period;

    const response = await axiosInstance.get('/job/apply/me/all', { params });
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get All My Applies API Error:', error);
    throw error;
  }
};

export const getApplicationDetail = async (jobId) => {
  try {
    const res = await axiosInstance.get(`/job/apply/job/${jobId}`);
    return res.data.data;
  } catch (error) {
    console.error('Get My Application Detail API Error:', error);
    throw error;
  }
};

export const deleteApplies = async (ids) => {
  try {
    const response = await axiosInstance.delete('/job/apply/delete', {
      data: { ids },
    });
    return response.data;
  } catch (error) {
    console.error('Delete Applies API Error:', error);
    throw error;
  }
};

export const getMyAppliesCount = async () => {
  try {
    const response = await axiosInstance.get('/job/apply/my-count');
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get My Applies Count API Error:', error);
    throw error;
  }
};

export const getOtherAppliesCount = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `/job/apply/other-count/${userId}`
    );
    return response.data.data;
  } catch (error) {
    console.error('Get Other Applies Count API Error:', error);
    throw error;
  }
};

export const getEmployerApplications = async (
  status,
  page = 0,
  size = 7,
  period = 'ALL',
  jobPostId = null,
  keyword = ''
) => {
  try {
    const params = { status, page, size };
    if (period !== 'ALL') params.period = period;
    if (jobPostId) params.jobPostId = jobPostId;
    if (keyword.trim()) params.keyword = keyword.trim();

    const response = await axiosInstance.get('/job/apply/employer', {
      params,
    });
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get Employer Applications API Error:', error);
    throw error;
  }
};

export const getEmployerApplicationCounts = async () => {
  try {
    const response = await axiosInstance.get('/job/apply/employer/count');
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get Employer Application Counts API Error:', error);
    throw error;
  }
};

export const updateEmployerApplicationStatus = async (
  applicationId,
  status,
  officialStartDate = null
) => {
  try {
    const params = { status };
    if (officialStartDate) params.officialStartDate = officialStartDate;

    const response = await axiosInstance.patch(
      `/job/apply/employer/applications/${applicationId}/status`,
      null,
      { params }
    );
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Update Employer Application Status API Error:', error);
    throw error;
  }
};

export const getEmployerApplicationDetail = async (applicationId) => {
  const response = await axiosInstance.get('/job/apply/employer/applications/' + applicationId);
  return response.data.data;
};
